import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const Contact = () => {
  return (
    <div className="contact-page">
      <Card>
        <Title level={2}>联系我们</Title>
        <Paragraph>
          如果您有任何问题或建议，请通过以下方式联系我们：
        </Paragraph>
        <ul>
          <li>邮箱: contact@example.com</li>
          <li>电话: +86 1234567890</li>
        </ul>
      </Card>
    </div>
  );
};

export default Contact;